import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import IsAuthenticat from "./IsAuthenticat";
import { selectedPartnerDetails } from "./Services/authenticationService";
import { slugifyTransform } from "./Utils/Helpers";

const AuthenticatedLoginRedirect = ({ children }) => {
    console.log('hjdhhjjfhdgjdhdgj')
  const navigate = useNavigate();
  const location = useLocation();
const selectedPartner = selectedPartnerDetails();
const partner = selectedPartner?.name
        ? slugifyTransform(selectedPartner.name)
        : "";
  useEffect(() => {
    const handleNavigation = () => {
      const token = IsAuthenticat();

      if (token && location.pathname === `/${partner}`) {
        navigate("/home", { replace: true });
      }
    };

    handleNavigation();

    window.addEventListener("pageshow", handleNavigation);

    return () => {
      window.removeEventListener("pageshow", handleNavigation);
    };
  }, [location.pathname, navigate]);

  const token = IsAuthenticat();

  if (token && location.pathname === `/${partner}`) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default AuthenticatedLoginRedirect;
